export default function () {
    const widgetName = 'multiScheduleFeature';
    const widgetOpts = multiScheduleFeatureOpts;

    $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');
    $(`#${widgetName}`).MultiScheduleFeature({
        scriptPath: widgetOpts.scriptPath
        , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
        , detectIpad: IPADDETECTED
        // options
        , allEventsLink: true
        , allEventsLinkText: 'view full event calendar'
        , hasImages: true
        , imageBackground: false
        , lazyLoadImages: true
        , buyNowButton: { visible: false, text: 'BUY NOW' }
        , moreButton: { visible: false, text: 'MORE' }
        , maxItemsVisible: 5
        , isResponsive: false
        , hasDescription: false
        , textContainer: false
        , link: 'all' //options are 'all', 'text', 'image', 'imageAndText', or ''
        , attributeOrder: {
            1: 'date',
            2: 'image',
            3: 'title',
            4: 'description',
            5: 'buttons',
        }
        , multiFeatureLoaded: function (data) {
            // console.log(data);
            // use function below if "more" text needs to appear at end of description text
            $('.all-events-btn').addClass('button')
            $('.featureItemDate').wrap('<div class="date-wrap"></div>')
            $('#multiScheduleFeature .featureItem').each(function () {
                const img = $(this).find('.featureItemImage img');
                const imgDataSrc = img.attr('data-src');
                if (imgDataSrc.includes('no_image_available.jpg')) {
                    img.attr('src', `${FULLCLIENTTHEMEPATH}images/no_image_available.jpg`);
                }
                var eventDate = $(this).find($('span.featureItemDate'));
                var datesMonth = eventDate.text().slice(0, 3);
                var datesDay = eventDate.text().slice(4, 7).replace(',', '');
                eventDate.text(datesMonth);
                eventDate.append("<span>" + datesDay + "</span>");
            });
        }
    });
};

